// extracted by mini-css-extract-plugin
export default {"base":"ImageGenerate_base__HLx1A","header":"ImageGenerate_header__9UXJG","tab":"ImageGenerate_tab__wmWJC"};